export const stats = [
  { value: "746K+", label: "Combined Subscribers" },
  { value: "31.1M+", label: "Total Views" },
  { value: "12", label: "Creators" },
  { value: "4.7K+", label: "Videos Published" },
];

export const creators = [
  { handle: "TheMoon", display_name: "The Moon Show", subscriber_count: 657000, view_count: 22900000, video_count: 786, category: "News", description: "The flagship channel. Crypto news, analysis & market updates.", featured: true },
  { handle: "Crypto-Kid", display_name: "Crypto Kid", subscriber_count: 66200, view_count: 6600000, video_count: 951, category: "Education", description: "Youngest crypto trader, bitcoin maximalist, macro trader & analyst.", featured: true },
  { handle: "champscrypto", display_name: "Champs Crypto Arabic", subscriber_count: 9900, view_count: 883000, video_count: 972, category: "Trading", description: "Champion-level crypto trader, Arabic content.", featured: false },
  { handle: "ChampsCryptoEng", display_name: "Champs Crypto", subscriber_count: 7100, view_count: 296500, video_count: 281, category: "Trading", description: "Champion-level crypto trader, market analysis in English.", featured: true },
  { handle: "jspizzlecrypto", display_name: "JSpizzle Crypto", subscriber_count: 2000, view_count: 106100, video_count: 417, category: "Memecoins", description: "Elite memecoin trader and content creator.", featured: false },
  { handle: "CryptoKidRU", display_name: "Crypto Kid RU", subscriber_count: 1200, view_count: 129200, video_count: 194, category: "Russian Voiceover", description: "Crypto Kid Russian voiceover channel.", featured: false },
  { handle: "Isaac-Crypto", display_name: "Isaac Crypto", subscriber_count: 1100, view_count: 52000, video_count: 120, category: "Analysis", description: "Technical crypto analyst & trader.", featured: false },
  { handle: "ItsCryptoElias", display_name: "Crypto Elias", subscriber_count: 1050, view_count: 59179, video_count: 367, category: "Bitcoin Trading", description: "Technical & fundamental bitcoin trader, pro-level analyst.", featured: false },
  { handle: "KriptoÇocuk", display_name: "Kripto Çocuk", subscriber_count: 930, view_count: 41000, video_count: 180, category: "Turkish Voiceover", description: "Crypto Kid Turkish voiceover channel.", featured: false },
  { handle: "CryptoElix", display_name: "Crypto Elix", subscriber_count: 593, view_count: 11418, video_count: 17, category: "Daily Market Updates", description: "Daily Bitcoin & crypto videos — market updates, altcoin insights and breaking news.", featured: false },
  { handle: "ferdietradescrypto", display_name: "Ferdie Trades Crypto", subscriber_count: 280, view_count: 32250, video_count: 237, category: "Trading", description: "Trading enthusiast, creative content creator.", featured: false },
  { handle: "CriptoNiño", display_name: "Cripto Niño", subscriber_count: 226, view_count: 18000, video_count: 150, category: "Spanish Voiceover", description: "Crypto Kid Spanish voiceover channel.", featured: false },
  { handle: "CryptoTifl", display_name: "Crypto Kid Arabic", subscriber_count: 139, view_count: 9000, video_count: 95, category: "Arabic Voiceover", description: "Crypto Kid Arabic voiceover channel.", featured: false },
];

export const featuredCreators = creators.filter((c) => c.featured);

export const brandBenefits = [
  { number: "01", title: "Vetted Creator Network", description: "Access crypto creators with real, engaged audiences — not random influencers." },
  { number: "02", title: "Authentic Reach", description: "Your brand promoted through voices your target users already trust." },
  { number: "03", title: "Campaign Management", description: "End-to-end campaign execution — from creator matching to content delivery." },
  { number: "04", title: "Measurable Results", description: "Transparent reporting on reach, engagement, and conversions." },
];

export const creatorBenefits = [
  { number: "01", title: "Full Incubation", description: "End-to-end brand building from strategy to execution." },
  { number: "02", title: "Premium Deals", description: "Access to top-tier sponsorships and partnerships." },
  { number: "03", title: "Collaboration", description: "Direct access to TheMoonShow & elite creator network." },
  { number: "04", title: "Growth Engine", description: "Data-driven strategies to maximize your reach." },
];

export const partners = [
  { id: 1, name: "BTCC", type: "Exchange", deal: "25% fee rebate + up to 100% deposit bonus above $200", url: "https://partner.btcc.com/us/c/TMMWEB/22885", active: true },
  { id: 2, name: "YuBit", type: "Exchange", deal: "25% fee rebate on all trades (lifetime) + up to 50% deposit bonus", url: "https://www.yubit.vip/register?inviteCode=TMM", active: true },
  { id: 3, name: "Weex", type: "Exchange", deal: "Coming Soon", url: null, active: false },
  { id: 4, name: "ByBit", type: "Exchange", deal: "Coming Soon", url: null, active: false },
  { id: 5, name: "Coinflare", type: "Exchange", deal: "Coming Soon", url: null, active: false },
  { id: 6, name: "LeveX", type: "Exchange", deal: "Coming Soon", url: null, active: false },
  { id: 7, name: "Padre.gg", type: "Gaming", deal: "Coming Soon", url: null, active: false },
];

export const socialPlatforms = [
  { platform: "Twitter / X", members: "Follow Us", abbr: "X", url: "https://x.com/TheMoonMediaHQ" },
  { platform: "YouTube", members: "85K+ Subscribers", abbr: "YT", url: "https://youtube.com/@Crypto-Kid" },
  { platform: "Discord", members: "Coming Soon", abbr: "DC", url: "#" },
  { platform: "Telegram", members: "Coming Soon", abbr: "TG", url: "#" },
];

export const subscriberOptions = [
  "Under 10K",
  "10K - 50K",
  "50K - 100K",
  "100K - 500K",
  "500K+",
];

export const budgetOptions = [
  "Under $5K",
  "$5K - $15K",
  "$15K - $50K",
  "$50K+",
];

export const campaignTypes = [
  "YouTube Sponsorship",
  "Twitter/X Campaign",
  "Multi-Platform",
  "Other",
];

export const howItWorks = [
  { step: "01", title: "Tell Us About Your Brand", description: "Share your project, goals, and target audience." },
  { step: "02", title: "Creator Matching", description: "We match you with creators that fit your audience and message." },
  { step: "03", title: "Content Production", description: "Creators produce and distribute authentic content featuring your brand." },
  { step: "04", title: "Results & Reporting", description: "Get transparent reporting on reach, engagement, and conversions." },
];

export const navLinks = [
  { path: "/", label: "Home" },
  { path: "/for-brands", label: "For Brands" },
  { path: "/creators", label: "Creators" },
  { path: "/community", label: "Community" },
  { path: "/get-started", label: "Get Started" },
  { path: "/partner-deals", label: "Deals" },
];
